import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { examineServerList, examineServerDel, examinePkgListS, examinePkgList, examinePkgDel, getServerListData } from "@/api/gmtool/packageCode";
import addExaminePkg from "./components/addExaminePkg.vue";
import addExamine from "./components/addExamine.vue";
import { gmTool } from "@/mixins/index";
export default {
  name: "examine",
  components: {
    addExamine: addExamine,
    addExaminePkg: addExaminePkg
  },
  mixins: [gmTool],
  data: function data() {
    return {
      activeIndex: '0',
      pageList: [{
        name: this.$t('pkgManagement'),
        tableData: [],
        paramsData: {
          page: 1,
          name: '',
          refresh_interval: '',
          page_size: 10,
          is_prod: ''
        },
        total: 0,
        reqFn: examinePkgList
      }, {
        name: this.$t('versionManagement'),
        tableData: [],
        paramsData: {
          page: 1,
          pkgData: '',
          version: '',
          page_size: 10,
          is_prod: ''
        },
        total: 0,
        reqFn: examineServerList
      }, {
        name: this.$t('examineList'),
        tableData: [],
        paramsData: {
          page: 1,
          is_prod: ''
        },
        total: 0,
        reqFn: getServerListData
      }],
      onoffList: [{
        label: this.$t('open'),
        value: 1
      }, {
        label: this.$t('close'),
        value: 0
      }],
      drawer: false,
      versionList: [],
      examinePkgList: [],
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      tableCopyTableList: []
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.pageList.forEach(function (i) {
                i.paramsData.is_prod = _this.paramsData.is_prod;
              });

              _this.getexaminePkgListS();

              _this.getList(1);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    getexaminePkgListS: function getexaminePkgListS() {
      var _this2 = this;

      examinePkgListS(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this2.examinePkgList = res.data;
        }
      });
    },
    pkgChange: function pkgChange() {
      this.getList(this.pageList[this.activeIndex].paramsData.page);
      this.getexaminePkgListS();
    },
    openView: function openView(row) {
      this.versionList = row.version_list.map(function (i) {
        return {
          value: i,
          pkgName: row.pkg_name,
          channelNmae: row.gm_channel_name
        };
      });
      this.drawer = true;
    },
    ListsizeChange: function ListsizeChange(e, index) {
      this.pageList[index].paramsData.page_size = e;
      this.getList(1);
    },
    getList: function getList() {
      var _this3 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.reqLoading = true;
      this.pageList[this.activeIndex].paramsData.page = e;
      this.pageList[this.activeIndex]['reqFn'](this.pageList[this.activeIndex].paramsData).then(function (res) {
        if (res.status == 200) {
          if (_this3.activeIndex == 2) {
            _this3.tableCopyTableList = JSON.parse(JSON.stringify(res.data));
            _this3.tableData = _this3.currentChangePage(_this3.pageSize, _this3.currentPage);
          } else {
            if (!res.data.data.length && e > 1) {
              _this3.getList(e - 1);
            } else {
              _this3.pageList[_this3.activeIndex].tableData = res.data.data;
              _this3.pageList[_this3.activeIndex].total = res.data.total;
            }
          }
        }
      }).finally(function () {
        _this3.reqLoading = false;
      });
    },
    modelChange: function modelChange(e) {
      this.activeIndex = e;

      if (!this.pageList[this.activeIndex].tableData.length) {
        this.getList();
      }
    },
    // 页数改变事件
    handleSizeChange: function handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.tableData = this.currentChangePage(pageSize, this.currentPage);
    },
    // 页码改变切换
    handleCurrentChange: function handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.tableData = this.currentChangePage(this.pageSize, currentPage);
    },
    // 分页方法
    currentChangePage: function currentChangePage(size, current) {
      var tablePush = [];
      this.tableCopyTableList.forEach(function (item, index) {
        if (size * (current - 1) <= index && index <= size * current - 1) {
          tablePush.push(item);
        }
      });
      return tablePush;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this4 = this;

      this.sels = [];
      val.forEach(function (e) {
        if (_this4.pageList[_this4.activeIndex].tableData.findIndex(function (i) {
          return i.id == e.id;
        }) > -1) {
          _this4.sels.push(e.id);
        }
      });
      this.selsString = this.sels.toString();
    },
    // 删除配置
    handleDelete: function handleDelete(id) {
      var _this5 = this;

      this.$confirm(this.$t('confirmDelete'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                examinePkgDel(_objectSpread({
                  id: id
                }, _this5.pageList[_this5.activeIndex].paramsData)).then(function (res) {
                  if (res.status == 200) {
                    _this5.getList(_this5.pageList[_this5.activeIndex].paramsData.page);

                    _this5.$message({
                      type: "success",
                      message: _this5.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};